/**
 * @file tabs.component.tsx
 * @description Компонент для отображения вкладок на форме с переключением между различными табами. Поддерживает динамическое отображение контента вкладок и интеграцию с react-hook-form для управления состоянием формы.
 * @author Genotroid | AI-Enhanced
 * @created 2025-09-03
 * @updated 2025-09-09
 * @dependencies ['react', '@consta/uikit/Tabs', '@src/types', 'react-hook-form']
 * @related-files ['src/types/tab-object.ts']
 */

import { createElement, useState } from 'react';
import { Tabs as ConstaTabs } from '@consta/uikit/Tabs';
import { tabObject } from '@src/types';
import { IBaseObjectDTO } from '@src/types/dto';
import { FullForm } from '@src/types/form-props';

/**
 * Props для компонента табов формы
 */
interface ITabsProps extends FullForm {
    /** Массив объектов вкладок для отображения */
    items: tabObject[];
    /** Данные формы для передачи в компоненты вкладок (переименован для ясности) */
    data?: IBaseObjectDTO;
}

export const Tabs = ({
    items,
    data,
    control,
    item,
    setValue,
    getValues,
    setError,
    formErrors,
    watch,
    clearErrors,
    errorListRef,
    ...props
}: ITabsProps) => {
    const [tab, setTab] = useState<tabObject>(items[0]);

    return (
        <div className="tab_component flex flex-col flex-1 relative h-full">
            <ConstaTabs
                value={tab}
                items={items}
                getItemLabel={(item: tabObject) => item.label}
                className="mb-tabs"
                {...props}
                onChange={(newTab) => setTab(newTab as tabObject)}
            />

            {tab?.component && (
                <div className="tab_component-content h-full w-full pr-[33.6852vmin]">
                    <div className="relative w-full h-full">
                        <div className="absolute overflow-y-auto w-full h-full pr-[2.0318vmin]">
                            {createElement(tab.component, {
                                ...tab,
                                control,
                                item,
                                setValue,
                                getValues,
                                setError,
                                formErrors,
                                watch,
                                clearErrors,
                                errorListRef
                            })}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
